<template>
  <div class="paymentSlipValidationDetails">
    <el-dialog
      :title="$t('data.payment_slip_verification_details')"
      class="diglog-card"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <!-- 核验基础信息 -->
      <div class="info-section">
        <div class="info-section-title">{{ $t('data.order_basic_info') }}</div>
        <div class="info-section-body">
          <div class="info-row">
            <span class="info-label">{{ $t('data.payment_verification_fee') }}</span>
            <span class="info-value info-value-amount">THB {{ detailData.verification_fee | toDivideWithDot }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.order_status') }}</span>
            <span class="info-value">
              <el-tag v-if="detailData.order_status" class="tag-custom" :type="getOrderStatusType(detailData.order_status)">{{ getOrderStatusLabel(detailData.order_status) }}</el-tag>
              <span v-else>-</span>
            </span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.final_verification_result') }}</span>
            <span class="info-value">
              <el-tag v-if="detailData.match_result" class="tag-custom" :type="getVerificationResultType(detailData.match_result)">{{ getVerificationResultLabel(detailData.match_result) }}</el-tag>
              <span v-else>-</span>
            </span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('merchantAccount.create_time') }}</span>
            <span class="info-value">{{ detailData.creation_time || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('merchantAccount.complete_time') }}</span>
            <span class="info-value">{{ detailData.completion_time || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.merchant_request_order_no') }}</span>
            <span class="info-value">{{ detailData.merchant_order_id || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.verification_serial_no') }}</span>
            <span class="info-value">{{ detailData.verification_serial_no || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.mini_qr_full_raw_content') }}</span>
            <span class="info-value">{{ detailData.mini_qr_raw_content || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.failure_info') }}</span>
            <span class="info-value">{{ detailData.failure_reason || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.transaction_amount_thb') }}</span>
            <span v-if="detailData.transaction_amount" class="info-value">{{ detailData.transaction_amount | toDivideWithDot }} </span>
            <span v-else class="info-value"> - </span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.country_code') }}</span>
            <span class="info-value">{{ detailData.country_code || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.transaction_date') }}</span>
            <span class="info-value">{{ detailData.transaction_date || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.transaction_time') }}</span>
            <span class="info-value">{{ detailData.transaction_time || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.transaction_reference_no') }}</span>
            <span class="info-value">{{ detailData.transaction_reference_no || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.reference_no_1') }}</span>
            <span class="info-value">{{ detailData.reference_no1 || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.reference_no_2') }}</span>
            <span class="info-value">{{ detailData.reference_no2 || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.reference_no_3') }}</span>
            <span class="info-value">{{ detailData.reference_no3 || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 收款方信息 -->
      <div class="info-section">
        <div class="info-section-title">{{ $t('data.receiver_info') }}</div>
        <div class="info-section-body">
          <div class="info-row">
            <span class="info-label">{{ $t('data.receiving_bank') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'receiver.bank_code') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.receiver_display_name') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'receiver.display_name') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.receiver_proxy_type') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'receiver.proxy_type') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.receiver_proxy_value') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'receiver.proxy_value') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.receiver_account_type') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'receiver.account_type') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.receiver_account_no') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'receiver.account_no') || '-' }}</span>
          </div>
        </div>
      </div>

      <!-- 付款方信息 -->
      <div class="info-section">
        <div class="info-section-title">{{ $t('data.sender_info') }}</div>
        <div class="info-section-body">
          <div class="info-row">
            <span class="info-label">{{ $t('data.sending_bank') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'sender.bank_code') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.sender_display_name') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'sender.display_name') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.sender_account_type') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'sender.account_type') || '-' }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('data.sender_account_no') }}</span>
            <span class="info-value">{{ getNestedField(detailData, 'sender.account_no') || '-' }}</span>
          </div>
        </div>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import { fetchPaymentSlipValidationDetail } from '@/api/data/data'
import {
  paymentSlipValidationOrderStatusMap,
  paymentSlipVerificationResultMap
} from '@/utils/maps'

export default {
  name: 'PaymentSlipValidationDetailModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      detailLoading: false,
      detailData: {}
    }
  },
  computed: {
    getOrderStatusType() {
      return function(value) {
        const result = paymentSlipValidationOrderStatusMap(value)
        return (result && result.type) || 'info'
      }
    },
    getOrderStatusLabel() {
      return function(value) {
        const result = paymentSlipValidationOrderStatusMap(value)
        return (result && result.label) || '-'
      }
    },
    getVerificationResultLabel() {
      return function(value) {
        const result = paymentSlipVerificationResultMap(value)
        return (result && result.label) || '-'
      }
    },
    getVerificationResultType() {
      return function(value) {
        const result = paymentSlipVerificationResultMap(value)
        return (result && result.type) || 'info'
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
    }
  },
  methods: {
    getNestedField(obj, path) {
      return path.split('.').reduce((o, k) => (o ? o[k] : undefined), obj)
    },
    changModalStatus(visible, verificationSerialNo) {
      this.dialogVisible = visible
      if (visible && verificationSerialNo) {
        this.getDetail(verificationSerialNo)
      }
    },
    handleDialogClose() {
      this.detailData = {}
    },
    getDetailInfo() {
      if (!this.detailData.verification_serial_no) return
      this.getDetail(this.detailData.verification_serial_no)
    },
    getDetail(verificationSerialNo) {
      this.detailLoading = true
      fetchPaymentSlipValidationDetail({ verification_serial_no: verificationSerialNo }).then(res => {
        if (res.code === 10000) {
          this.detailData = res.data || {}
        }
      }).finally(() => {
        this.detailLoading = false
      })
    }
  }
}
</script>

<style>
.paymentSlipValidationDetails .el-dialog__body {
  padding: 16px 20px 30px;
}
</style>

<style scoped lang="scss">
.paymentSlipValidationDetails {
  .info-section {
    margin-top: 24px;
    border: 1px solid #D3D7DF;
    border-radius: 4px;
    padding: 16px;

    &:first-child {
      margin-top: 0;
    }
  }

  .info-section-title {
    font-size: 14px;
    font-weight: 500;
    font-family: 'Inter-Medium';
    color: #1D3A71;
    margin-bottom: 16px;
    padding-bottom: 12px;
    border-bottom: 1px solid #D3D7DF;
  }

  .info-section-body {
    display: flex;
    flex-direction: column;
  }

  .info-row {
    display: flex;
    align-items: flex-start;
    padding: 8px 0;
    border-bottom: 1px solid #F2F3F5;

    &:last-child {
      border-bottom: none;
    }
  }

  .info-label {
    flex-shrink: 0;
    width: 240px;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Inter-Regular';
    color: #606266;
    line-height: 20px;
  }

  .info-value {
    flex: 1;
    font-size: 14px;
    font-weight: 400;
    font-family: 'Inter-Regular';
    color: #4B5567;
    line-height: 20px;
    word-break: break-all;

    &.info-value-amount {
      font-weight: 600;
      font-family: 'Inter-SemiBold';
      color: #3855F1;
    }
  }

  .tag-custom {
    font-size: 12px;
    padding: 2px 8px;
    border: none;
  }
}
</style>
